import { GetAddressesForFilterActionTypes, GetAddressesForFilterState, GET_ADDRESSES_FOR_FILTER_FAILURE, GET_ADDRESSES_FOR_FILTER_REQUEST, GET_ADDRESSES_FOR_FILTER_SUCCESS } from './types';

const defaultState: GetAddressesForFilterState = {
  isLoading: false,
  errorMessage: ''
};

export default function getAddressesForFilter(state = defaultState, action: GetAddressesForFilterActionTypes): GetAddressesForFilterState {
  switch (action.type) {
    case GET_ADDRESSES_FOR_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_ADDRESSES_FOR_FILTER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ''
      };
    case GET_ADDRESSES_FOR_FILTER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};